import { durationTrendScale } from '@flakiness/shared/common/utils.js';
import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('fk-number-trend')
class FKNumberTrend extends LitElement {
  @property({ attribute: false }) baseline?: number;
  @property({ attribute: false }) value?: number;
  @property({ type: Boolean }) icon?: boolean;

  override render() {
    const value = this.value;
    const baseline = this.baseline;
    if (value === undefined || baseline === undefined)
      return nothing;
    const change = value - baseline;
    const icon = this.icon ? html`<sl-icon name=${change >= 0 ? 'graph-up-arrow' : 'graph-down-arrow'}></sl-icon>` : nothing;
    const scale = baseline !== 0 ? ` (${durationTrendScale(value, baseline)})` : '';
    return html`
      <span>
        ${icon}
        <span>${change < 0 ? '' : '+'}${change}${scale}</span>
        <span class=separator>—</span> <int-num .x=${value}></int-num>
      </span>
    `;
  }

  static styles = [css`
    :host {
      display: inline-flex;
      align-items: center;
      white-space: nowrap;
    }

    .separator {
      font-weight: var(--sl-font-weight-light);
      color: var(--sl-color-neutral-500);
    }

    sl-icon {
      margin-right: var(--sl-spacing-2x-small);
    }
  `];
}
